import React, { useState, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ContractVariables from "./ContractVariables";
import PropTypes from "prop-types";
import "./EmpContractTemplate.css";
const variables = [
  "employeeName",
  "employeeCode",
  "designation",
  "salary",
  "joiningDate",
];

const EmpContractTemplate = ({ content, setContent, variables, isLoading, title, setTitle }) => {
  // const [content, setContent] = useState("");
  const editorRef = useRef(null);

  // 👉 Insert variable into editor
  const insertVariable = (variable) => {
    const editor = editorRef.current;

    if (!editor) return;

    editor.model.change((writer) => {
      const insertPosition = editor.model.document.selection.getFirstPosition();

      writer.insertText(`{{${variable}}}`, insertPosition);
    });
  };


  return (
    <div className="row">
      {/* 🔹 LEFT SIDE - VARIABLES */}
      <div className="col-3">
        <ContractVariables
          insertVariable={insertVariable}
          variables={variables}
          isLoading={isLoading}
        />
      </div>

      {/* 🔹 RIGHT SIDE - EDITOR */}
      <div className="col-9">
        <div className="mb-3">
          <label className="form-label">Title <span className="asterisk">*</span></label>
          <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div className="mb-3">
          <label className="form-label">Template Form <span className="asterisk">*</span></label>
          <CKEditor
            editor={ClassicEditor}
            data={content}
            onReady={(editor) => {
              editorRef.current = editor;
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              setContent(data);
            }}
          />
        </div>

        {/* <button
          onClick={() => console.log(content)}
          className="btn btn-primary mt-3"
        >
          Save
        </button> */}
      </div>
    </div>
  );
};

EmpContractTemplate.propTypes = {
  content: PropTypes.string.isRequired,
  setContent: PropTypes.func.isRequired,
  variables: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  setTitle: PropTypes.func.isRequired,
};

export default EmpContractTemplate;
